import type {LoaderFunctionArgs} from 'react-router'
import {redirect, useLoaderData} from 'react-router-dom'

import {getNavigationState} from '../../helpers/navigationStateCache.ts'
import {withRouter} from '../../hocs/withRouter'
import RatingComponent from './index'
import {getInitialProps} from './initialProps'

import './styles/index.scss'

export async function loader({context, request, params}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`

  const routeInfo = {
    location: {
      pathname,
      query: Object.fromEntries(url.searchParams.entries()),
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {
      tradeId: params.tradeId
    }
  }

  const data = await getInitialProps({routeInfo, context})

  if (data?.__HTTP__?.redirectTo) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw redirect(data.__HTTP__.redirectTo)
  }

  return data
}

const RatingWithRouter = withRouter(RatingComponent)

export function Component() {
  const data = useLoaderData()
  return <RatingWithRouter {...data} />
}
